module.exports = __webpack_public_path__ + "img/flags.56780283.svg";